<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web" style="height:auto">
            <br />
            <CRow class="ml-2">
              <span v-if="student.profileImagePath == ''" class="custom-header-profile">
                <img
                  width="50px"
                  height="50px"
                  src="../../assets/img/icon/userprofile2.svg"
                />     
              </span>

              <span v-else class="custom-header-profile">
                <img 
                  :src="photoURL" 
                  width="50px"
                  height="50px"
                  style="border-radius: 30px;"
                />           
              </span>

              <span class="custom-user-title ml-2"> {{ student.studentName }} </span>
              <span class="custom-sub-grade" style="color: #007CEF;"> {{ student.gradeName }} </span>
            </CRow>

            <h4 style="color: #000; text-align: left" class="custom-user-grade">
              Select Subjects
            </h4>
            <br />
            
            <div class="list-grade">
              <CRow>
                <CCol
                  sm="12"
                  v-for="item in subject"
                  v-bind:key="item.id"
                  @click="GoToLanguage(item.subjectName , item.id)"
                >
                  <div class="">
                    <input
                      type="checkbox"
                      id="item.id"
                      v-model="item.subjectName"
                      class="mr-2 ml-2"
                    />
                     {{ item.subjectName }} 
                  </div>
                  <div style="clear: both"></div>
                  <hr />
                </CCol>
              </CRow>
            </div>
          </div>
        </div>
      </div>
      <MainlayoutBottom></MainlayoutBottom>
    </CContainer>

    

    <div style="clear: both"></div>
    <div class="header-top">Subjects</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import MainlayoutBottom from "../../containers/TheBottomCustom.vue";

export default {
  components: {
    MainlayoutBottom,
  },
  data: function () {
    return {
      user: {},
      subject: [],
      student: {},
      // FilterSubject: [],
      StudentId: this.$route.query.studentId,
      GradeId: this.$route.query.gradeId,
      
      // Exam: this.$route.query.Exam,
      // SearchQuery: "",
      // SelectedSubject: "",

      // studentProfileAuthorize: "",

      // choices: [
      //   { 
      //       choice: "Bahasa Malaysia"
      //   },
      //   { 
      //       choice: "English"
      //   },
      //   { 
      //       choice: "Math"
      //   },
      //   { 
      //       choice: "Pendidikan Islam"
      //   },
      //   { 
      //       choice: "Additional Mathematics"
      //   },      
      // ],

    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetSubject();
            this.GetStudent(this.$route.query.studentId);
          }
        });
    },

    GetStudent() {
      this.$API
        .get(this.$StudentProfile + "?studentId=" + this.$route.query.studentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.student = response.data;
            this.photoURL = "https://pickiddo.com" + this.student.profileImagePath;
            this.studentid = this.student.id;            
            console.log("student", this.student.profileImagePath);
          }
        });
    },

    GetSubject() {
      this.$API
        .get(this.$ListSubjectByCountryId + "?countryId=" + this.user.countryId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subject = response.data;
            console.log("subject", this.subject);
          }
        });
    },

    GoToLanguage(subjectName, id) {
      // this.$router.push(
      //   "/FindTutor/FTLanguage?studentId=" +
      //   this.$route.query.studentId +
      //   "&gradeId=" +
      //   this.$route.query.gradeId +
      //   "&subjectId=" +
      //   id +
      //   "&subjectName=" +
      //   subjectName        
      // );


      const hasTeacherId = this.$route.query.hasOwnProperty('teacherId');

if (hasTeacherId) {
  this.$router.push(
        "/FindTutor/FTLanguage?studentId=" +
        this.$route.query.studentId +
        "&gradeId=" +
        this.$route.query.gradeId +
        "&subjectId=" +
        id +
        "&subjectName=" +
        subjectName + "&teacherId=" + this.$route.query.teacherId);
} else {
  this.$router.push(
        "/FindTutor/FTLanguage?studentId=" +
        this.$route.query.studentId +
        "&gradeId=" +
        this.$route.query.gradeId +
        "&subjectId=" +
        id +
        "&subjectName=" +
        subjectName
      );
}
    },
    
    GoBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input[type="text"] {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}
input[type="checkbox"] {
opacity: 0;
}
input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: 100vh;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}
</style>